import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-2089">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-2090">
        <img src="https://cdn.magicpatterns.com/uploads/apJvfBStMi2YLnfZWoZHky/new_logo.png" alt="EDM Network Logo" className="h-16 md:h-20 w-auto mx-auto block" data-id="element-2091" />
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-2092">
          EDM Network
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-2093">
          Complete EDM & CNC Milling Solutions
        </p>
      </div>
    </div>;
}